import { createIcons, icons } from "lucide";

export const initIcons = () => {
  createIcons({ icons });
};
